const ICON_COMMON = {
  add: 'fi fi-rr-plus',
  edit: 'fi fi-rr-edit',
  view: 'fi fi-rr-eye',
  trash: 'fi fi-rr-trash',
  save: 'fi fi-rr-check',
  import: 'fi fi-rr-inbox-in',
  export: 'fi fi-rr-inbox-out',
  bought: 'fi fi-rr-shopping-cart-add',
  email: 'fa fa-share',
  sms: 'fa fa-rss',
  print: 'fi fi-rr-print',
  money: 'fi fi-rr-dollar',
};
export default ICON_COMMON;
